// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:520px;
`;




export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
min-height: 396px;
`;

export const FeaturedBanner = styled.div
.attrs(() => ({
  className: '',
}))`
width:100%;
min-height: 432px;
background: #D9D9D9;
border-radius: 15px
`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
// width: 359px;
min-height: 38px;
font-family: 'Cabinet Grotesk-b';
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;
export const HeadingTextX = styled.h1
.attrs(() => ({
  className: 'red',
}))`
font-family: 'Cabinet Grotesk-b';
font-style: normal;
font-weight: 700;
font-size: 36px;
line-height: 103%;
/* identical to box height, or 37px */
color: #282828;

margin-bottom:0px !important;
margin-left:-20px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;


export const ExcaptText = styled.p
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 142.5%;
color: #4A4A4A;
text-decoration:justify;
@media screen and (max-width: 425px) {
    width:auto !important;
}
`;


export const Cardde = styled.div
.attrs(() => ({
  className: 'transaparent',
}))`

.card-image{
height: 306px;
// border:2px dashed red;
border-radius: 10px;
   background:#D9D9D9;
}
.card-content{
    padding:0px;
}
`;

export const Button  = styled.a
.attrs(() => ({
  className: ' btn btn-large btn-flat center  ',
}))`
background: #D9D9D9;
border-radius: 5px;
font-family: 'Cabinet Grotesk-regular' !important;
font-style: normal;
font-weight: 700;
font-size: 14.9425px;
text-transform:none !important;

`;